import React, { useState } from "react";

const WeChatFloatingButton = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setShowModal(true)}
        style={{
          position: "fixed",
          bottom: "100px",
          right: "15px",
          backgroundColor: "#1AAD19",
          borderRadius: "50%",
          width: "50px",
          height: "50px",
          border: "none",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          cursor: "pointer",
          zIndex: 999,
        }}
      >
        <img src="/img/wechat-icon.png" alt="WeChat" />
      </button>

      {/* Modal */}
      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              padding: "0.2rem",
              borderRadius: "10px",
              maxWidth: "300px",
              width: "80%",
              textAlign: "center",
              position: "relative",
            }}
          >
            <img
              src="/img/QR-code1.jpg" // Replace with your QR code
              alt="WeChat QR Code"
              style={{ width: "100%", marginTop: "1rem" }}
            />
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: "0",
                right: "10px",
                background: "transparent",
                border: "none",
                fontSize: "1.5rem",
                color: "red",
                cursor: "pointer",
              }}
              aria-label="Close modal"
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default WeChatFloatingButton;
